import React, { memo, PropsWithChildren } from "react";

import { Modal as AntdModal } from "antd";
import { ModalProps } from "antd/lib/modal";

const Modal = ({ children, ...props }: PropsWithChildren<ModalProps>) => {
  return <AntdModal {...props}>{children}</AntdModal>;
};

export default memo(Modal);
